module.exports = __webpack_public_path__ + "assets/images/f4929b1df5e4a73824898edf13fe3009.png";